export { loader } from "~/components/brandCustomPage/products/BrandTabbedProductShelf"

import { type SectionProps } from "~/types/deco"
import {
  default as Component,
  loader,
} from "~/components/brandCustomPage/products/BrandTabbedProductShelf"

/**
 * @title Prateleira com Abas
 */
export default function Section(props: SectionProps<typeof loader>) {
  return <Component {...props} />
}

export function LoadingFallback() {
  return (
    <div style={{ height: '716px' }} className='flex justify-center items-center'>
      <span className='loading loading-spinner' />
    </div>
  )
}
